import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

// Connects to data-controller="yu-baby-feedback-callback"
export default class extends Controller {
  static targets = ['successModal']

  static values = { errorMessage: String }

  static outlets = ['yu-baby-message']

  connect() {
    if (this.errorMessageValue) {
      const errorMessage = `エラーが発生しました : ${this.errorMessageValue}`
      this.yuBabyMessageOutlet.setErrorMessage(errorMessage)
    } else {
      Modal.getInstance(this.yuBabyMessageOutlet.feedbackModalTarget).hide()
      new Modal(this.successModalTarget).show()
    }
  }
}
